import { getLocalTimeZone, today } from '@internationalized/date'
import { differenceInCalendarMonths, parseISO } from 'date-fns'

export class PrazoPagamentoSimulacao {
  constructor(
    private readonly dataSimulacao: string,
    private readonly dataUltimaParcela: string = today(getLocalTimeZone()).toString(),
  ) {}

  get prazoPagamentoEmMeses() {
    return differenceInCalendarMonths(parseISO(this.dataUltimaParcela), parseISO(this.dataSimulacao))
  }
}
